<!-- title -->
<app-modal-title
  [title]="'pages.sendSmartSmsToResidents.createRequest' | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content>
  <p>{{ "messages.pleaseEnterRequestNameToContinue" | translate }}</p>

  <form-field class="tw-w-full" label="common.title" [(value)]="requestName">
    <i suffix-content class="mdi mdi-text-box-multiple mdi-23px"></i>
  </form-field>
</div>
<div mat-dialog-actions>
  <div class="tw-w-1/2 tw-px-1">
    <button class="btn tw-w-full" [themeColor]="'cancel-btn'" (click)="onClose()">
      {{ "common.cancel" | translate }}
    </button>
  </div>
  <div class="tw-w-1/2 tw-px-1">
    <button
      class="btn tw-w-full"
      [themeColor]="'btn'"
      [mat-dialog-close]="requestName"
      cdkFocusInitial
      [disabled]="okButtonActive() == false"
    >
      {{ "common.submit" | translate }}
    </button>
  </div>
</div>
